import React from 'react';
import config from '../config';
import BackButton from './BackButton';

function SavedPriorArtSearchesPage({ 
  setPage, 
  savedPriorArtSearches, 
  setSavedPriorArtSearches,
  setPriorArtForm,
  setPriorArtResults
}) {
  
  const handleViewResults = (search) => {
    setPriorArtForm({
      invention_title: search.invention_title,
      invention_description: search.invention_description,
      distilled_claim: search.full_report?.distilled_claim || '',
      priority_date: search.priority_date,
      key_features: search.key_features || ['', '', ''],
      known_competitors: '',
      jurisdiction: search.jurisdiction || 'US',
      report_type: search.report_type || 'attorney'
    });
    setPriorArtResults(search.full_report && Object.keys(search.full_report).length > 0 ? {
      ...search.full_report,
      report_type: search.report_type || search.full_report.report_type || 'attorney'
    } : {
      results: search.results || [],
      total_found: search.total_found,
      results_shown: search.results?.length || 0,
      search_strategy: search.search_strategy || {},
      report_type: search.report_type || 'attorney'
    });
    setPage('prior-art');
  };

  const handleDelete = async (searchId) => {
    if (window.confirm('Are you sure you want to delete this report?\n\nThis action cannot be undone.')) {
      const token = localStorage.getItem('token');
      try {
        const response = await fetch(config.API_URL + "/api/prior-art-searches/" + searchId + "?token=" + token, {
          method: 'DELETE'
        });
        const data = await response.json();
        if (data.success) {
          setSavedPriorArtSearches(savedPriorArtSearches.filter(s => s.id !== searchId));
        } else {
          alert('Failed to delete report');
        }
      } catch (error) {
        console.error('Delete error:', error);
        alert('Failed to delete report');
      }
    }
  };

  const getReportTypeLabel = (search) => {
    if (search.report_type === 'attorney') {
      const jurisdiction = search.jurisdiction === 'US' ? 'US' : search.jurisdiction === 'UK_EPO' ? 'UK/EPO' : search.jurisdiction === 'EPO' ? 'EPO' : search.jurisdiction === 'EPO_STRICT' ? 'EPO Strict' : 'US';
      return "ATTORNEY (" + jurisdiction + ")";
    } else if (search.report_type === 'tto') {
      return 'TTO';
    } else if (search.report_type === 'commercial') {
      return 'COMMERCIAL';
    }
    return 'REPORT';
  };

  return (
    <div style={{ minHeight: '100vh', background: 'white' }}>
      <header style={{ padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <BackButton onClick={() => setPage('search')} />
          <img src="/logo.svg" alt="PatTrak Logo" style={{ height: '32px', cursor: 'pointer' }} onClick={() => setPage('search')} />
        </div>
      </header>

      <main style={{ maxWidth: '900px', margin: '40px auto', padding: '0 16px' }}>
        <h1 style={{ fontSize: '32px', fontWeight: 'bold', color: '#1d2934', marginBottom: '24px' }}>
          Saved Prior Art Searches
        </h1>

        {savedPriorArtSearches.length === 0 ? (
          <p style={{ fontSize: '16px', color: '#5e778a' }}>You haven't saved any prior art searches yet.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {savedPriorArtSearches.map((search) => (
              <div key={search.id} style={{ border: '1px solid #90caf9', background: '#f5f9ff', padding: '20px', borderRadius: '8px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div>
                    <h3 style={{ fontSize: '20px', fontWeight: '600', color: '#1d2934', marginBottom: '8px' }}>
                      {search.invention_title}
                    </h3>
                    <p style={{ fontSize: '14px', color: '#5e778a', marginBottom: '8px' }}>
                      <span style={{
                        background: search.report_type === 'attorney' ? '#7b1fa2' : search.report_type === 'tto' ? '#1a237e' : '#2e7d32',
                        color: 'white',
                        padding: '2px 8px',
                        borderRadius: '4px',
                        fontSize: '11px',
                        fontWeight: 'bold',
                        marginRight: '8px'
                      }}>
                        {getReportTypeLabel(search)}
                      </span>
                      Priority Date: {search.priority_date} | Patents Found: {search.total_found} | Searched: {search.search_date ? new Date(search.search_date).toLocaleDateString() : 'Unknown'}
                    </p>
                    <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.5' }}>
                      {search.invention_description?.substring(0, 200)}{search.invention_description?.length > 200 ? '...' : ''}
                    </p>
                  </div>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <button
                      onClick={() => handleViewResults(search)}
                      style={{
                        background: '#1976d2',
                        color: 'white',
                        padding: '10px 20px',
                        borderRadius: '4px',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '600',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      View Results
                    </button>
                    <button
                      onClick={() => handleDelete(search.id)}
                      style={{
                        background: '#c62828',
                        color: 'white',
                        padding: '10px 16px',
                        borderRadius: '4px',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}

export default SavedPriorArtSearchesPage;
